import React from "react";

import TopicsListItem from "./TopicsListItem";
import NoResults from "../../../common/NoResults";
import { SonicTopicsData } from "../../../common/classes/SonicTopics";

import styles from "../../management/db-list/DBList.module.scss";

type Props = {
  topics: Array<SonicTopicsData>;
  authors: Array<{ name: string; email: string; roles: Array<string> }>;
};

const TopicsList: React.FC<Props> = ({ topics, authors }) => {
  if (topics.length === 0) return <NoResults />;

  return (
    <div className={styles["f-dbList"]}>
      <div
        className={`${styles["f-dbList__category"]} ${styles["head"]} ${styles["topics"]}`}
      >
        <div>トピックス名</div>
        <div>カテゴリ</div>
        <div>作成者名</div>
        <div>掲載開始日</div>
        <div>ステータス</div>
        <div>アクション</div>
      </div>
      {topics?.map((topic, i) => (
        <TopicsListItem
          key={i}
          id={topic.id}
          name={topic.name}
          category={topic.topic_type}
          author={authors?.[i]}
          start_date={topic.start_date}
          status={topic.status}
        />
      ))}
    </div>
  );
};

export default TopicsList;
